module.exports = __webpack_public_path__ + "img/immobilizer.092aa03b.png";